import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { DateTime } from 'luxon';

import {
    Box, Divider, Typography, Grid, Button, Container, Fab, FormControl, TextField, Autocomplete,
    Paper, FormControlLabel, FormGroup, Checkbox
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import CustomMessage from '../../utils/components/CustomMessage';
import CustomChip from '../../utils/components/CustomChip';

import { formatMoney } from '../../utils/functions/Utils';

function EditarGasto() {

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [concepto, setConcepto] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [destino, setDestino] = useState('');
    const [tipoDeMovimiento, setTipoDeMovimiento] = useState('');
    const [monto, setMonto] = useState(0);
    const [fecha, setFecha] = useState(DateTime.now());
    const [formaDePago, setFormaDePago] = useState('');
    const [factura, setFactura] = useState({ flag: false, noFactura: '' });
    const [fechaFactura, setFechaFactura] = useState(DateTime.now());
    const [responsable, setResponsable] = useState('');
    const [justificacion, setJustificacion] = useState('');
    const [observaciones, setObservaciones] = useState('');

    const [apiRes, setApiRes] = useState({ show: false, message: '', severity: '' });

    const tiposDeMovimiento = ['Compra', 'Envío', 'Mercado Libre', 'Pago de Servicio', 'Pago de Nomina', 'Pago de Impuestos', 'Pago de Prestamo', 'Otro', ''];
    const formasDePago = ['Efectivo', 'Tarjeta', 'Transferencia', 'Mercado Pago', 'Cheque', ''];

    // get id from url
    let { id } = useParams()

    useEffect(() => {
        if (!['Admin'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Agregar Gasto';
    }, [auth])


    const handleCloseMessage = (show) => {
        setApiRes(state => { return { ...state, show: show } })
    }

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        try {
            let res = await axios.get(`/api/gastos/${id}`);
            if (res.status === 200) {
                const gasto = res.data;
                setConcepto(gasto.concepto);
                setDescripcion(gasto.descripcion);
                setDestino(gasto.destino);
                setTipoDeMovimiento(gasto.tipoDeMovimiento);
                setMonto(gasto.monto);
                setFecha(DateTime.fromISO(gasto.fecha));
                setFormaDePago(gasto.formaDePago);
                setFactura(gasto.factura);
                setFechaFactura(DateTime.fromISO(gasto.factura.fechaFactura));
                setResponsable(gasto.responsable);
                setJustificacion(gasto.justificacion);
                setObservaciones(gasto.observaciones);
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al cargar el gasto, favor de intentarlo mas tarde', severity: 'error' } });
            console.log(err);
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const gasto = {
            concepto: concepto,
            descripcion: descripcion,
            destino: destino,
            tipoDeMovimiento: tipoDeMovimiento,
            monto: monto,
            fecha: fecha,
            formaDePago: formaDePago,
            factura: {
                flag: factura.flag,
                fechaFactura: fechaFactura,
                noFactura: factura.noFactura

            },
            responsable: responsable,
            justificacion: justificacion,
            observaciones: observaciones
        };

        try {
            const res = await axios.post(`/api/gastos/${id}`, { gasto: gasto });
            if (res.status === 200) {
                setApiRes(state => { return { ...state, show: true, message: 'Modificación completa', severity: 'success' } });
                setTimeout(() => {
                    navigate('/gastos');
                }, 800);
            }
        } catch (err) {
            setApiRes(state => { return { ...state, show: true, message: 'Ocurrió un error al crear el documento, favor de intentarlo de nuevo', severity: 'error' } });
            console.log(err);
        }
    }

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>
            <Paper sx={{ padding: '24px 0px' }} elevation={3}>

                <Container maxWidth='xl'>
                    <Box className='text-center' >
                        <Typography variant='h5' style={{ fontWeight: 700 }}>Agregar Gasto</Typography>
                    </Box>

                    <Button size='small' variant='outlined' onClick={() => navigate('/gastos')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                    <Divider className='my-3' textAlign="left">
                        <CustomChip variant='outlined' estatus='AUTORIZADO' label='Detalles' className='text-bold' />
                    </Divider>

                    <form onSubmit={(e) => handleSubmit(e)}>
                        <Fab aria-label="add" type='submit' color='success' style={{ position: 'fixed', top: '60px', left: '12px', zIndex: '10', opacity: '60%' }}>
                            <i className="fad fa-save fa-2x"></i>
                        </Fab>

                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Concepto" variant="outlined" value={concepto} onChange={(e) => setConcepto(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField multiline label="Descripcion" variant="outlined" value={descripcion} onChange={(e) => setDescripcion(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Destino / Proveedor" variant="outlined" value={destino} onChange={(e) => setDestino(e.target.value)} />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6} lg={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <DatePicker
                                        label="Fecha de Pago"
                                        format="dd/MM/yyyy"
                                        value={fecha}
                                        onChange={(newValue) => setFecha(newValue)}
                                        slotProps={{ textField: { variant: 'outlined' } }}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={6} lg={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setTipoDeMovimiento(newInputValue)}
                                        inputValue={tipoDeMovimiento}
                                        options={tiposDeMovimiento}
                                        renderInput={(params) => <TextField {...params} label='Tipo de Movimiento' required />}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField error={isNaN(Number(monto)) ? true : false} helperText={isNaN(Number(monto)) ? 'El monto debe ser un número' : `$ ${formatMoney(monto)}`} label="Monto (IVA incluido)" variant="outlined" value={monto} onChange={(e) => setMonto(e.target.value)} />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <FormControl required sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <Autocomplete
                                        disablePortal
                                        freeSolo={true}
                                        onInputChange={(event, newInputValue) => setFormaDePago(newInputValue)}
                                        inputValue={formaDePago}
                                        options={formasDePago}
                                        renderInput={(params) => <TextField {...params} label='Forma de Pago' />}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item sm={12} md={2}>
                                <FormGroup>
                                    <FormControlLabel labelPlacement="top" label='Factura' control={<Checkbox checked={factura.flag} onChange={() => setFactura({ ...factura, flag: !factura.flag })} />} />
                                </FormGroup>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="# Factura" variant="outlined" value={factura.noFactura} onChange={(e) => setFactura({ ...factura, noFactura: e.target.value })} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <DatePicker
                                        label="Fecha de Facturación"
                                        format="dd/MM/yyyy"
                                        value={fechaFactura}
                                        onChange={(newValue) => setFechaFactura(newValue)}
                                        slotProps={{ textField: { variant: 'outlined' } }}
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField label="Reesponsable" variant="outlined" value={responsable} onChange={(e) => setResponsable(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField multiline label="Justificación" variant="outlined" value={justificacion} onChange={(e) => setJustificacion(e.target.value)} />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} style={{ display: 'flex' }}>
                                    <TextField multiline label="Observaciones" variant="outlined" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
                                </FormControl>
                            </Grid>
                        </Grid>
                        <hr></hr>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <Button variant="contained" color="success" type='submit'>Guardar &nbsp; <i className="fad fa-save"></i></Button>
                            </Grid>
                        </Grid>
                    </form>
                </Container>
                <CustomMessage open={apiRes.show} message={apiRes.message} severity={apiRes.severity} handleCloseMessage={handleCloseMessage} />
            </Paper>
        </Container>
    );
}

export default EditarGasto;